import TrackHome from "@/components/TrackHome";
import { INDUSTRIAL_HOME } from "@/data/track-content";
import { INDUSTRIAL_SERVICES_DATA } from "@/data/industrial-services";
import { PAGE_META } from "@/lib/seo-constants";

export default function IndustrialHome() {
    return (
        <TrackHome
            trackKey="industrial"
            content={INDUSTRIAL_HOME}
            servicesData={INDUSTRIAL_SERVICES_DATA}
            meta={PAGE_META.industrialHome}
        />
    );
}
